import React, { createContext, useContext, useMemo } from 'react'
import { useTheme } from '@mui/material/styles'
import {
  DARK_HEADER_COLOR_SCHEME,
  HeaderColorScheme,
  LIGHT_HEADER_COLOR_SCHEME,
} from '../../components/layout/headerColorVariants'

interface HeaderColorContextValue {
  scheme: HeaderColorScheme
}

const HeaderColorContext = createContext<HeaderColorContextValue | null>(null)

HeaderColorContext.displayName = 'HeaderColorContext'

interface HeaderColorContextProviderProps {
  children: React.ReactNode
}

export const HeaderColorContextProvider: React.FC<HeaderColorContextProviderProps> = ({ children }) => {
  const theme = useTheme()
  const scheme = theme.palette.mode === 'dark' ? DARK_HEADER_COLOR_SCHEME : LIGHT_HEADER_COLOR_SCHEME
  const value = useMemo(() => ({ scheme }), [scheme])

  return <HeaderColorContext.Provider value={value}>{children}</HeaderColorContext.Provider>
}

export const useHeaderColorScheme = (): HeaderColorContextValue => {
  const value = useContext(HeaderColorContext)
  if (!value) throw new Error('Header color context must be initialized before using it')
  return value
}
